<template>
  <div style="position: relative; z-index: 9999">
    <div class="header-box" :class="topVal ? 'header-active' : ''">
      <img src="@/assets/logo.png" class="logo" />
      <div class="nav-box">
        <!-- <div
          v-for="(item, index) in nav"
          :key="index"
          :class="item.path === navAct ? 'nav nav-active' : 'nav'"
          @click="toPage(item)"
          @mouseenter="downMenu(item.title)"
          @mouseleave="upMenu(item.title)"
        >
          <span>{{ item.title }}</span>
          <div class="line" v-show="navAct === item.path"></div>
        </div> -->
        <div
          v-for="(item, index) in nav"
          :key="index"
          @mouseenter="downMenu(item.title)"
          @mouseleave="upMenu(item.title)"
        >
          <router-link
            :to="item.path"
            :class="$route.meta.index === index ? 'nav nav-active' : 'nav'"
          >
            <span>{{ item.title }}</span>
            <div class="line" v-show="$route.meta.index === index"></div>
          </router-link>
        </div>
      </div>
      <!-- 解决方案 -->
      <div
        class="secondary-menu-box"
        :class="solution ? 'secondary-menu-box-down' : ''"
        @mouseenter="solution = true"
        @mouseleave="solution = false"
      >
        <div class="secondary-menu">
          <div
            class="menu-item"
            v-for="(item, index) in nav[1].child"
            :key="index"
          >
            <router-link :to="item.path" class="menu-item">
              {{ item.name }}
            </router-link>
          </div>
        </div>
      </div>
      <!-- 产品中心 -->
      <div
        class="secondary-menu-box secondary-menu-box-two"
        :class="
          product ? 'secondary-menu-box-down secondary-menu-box-two-down' : ''
        "
        @mouseenter="product = true"
        @mouseleave="product = false"
      >
        <div class="secondary-menu">
          <div
            class="menu-item"
            v-for="(item, index) in nav[2].child"
            :key="index"
          >
            <router-link :to="item.path" class="menu-item">
              {{ item.name }}
            </router-link>
          </div>
        </div>
      </div>
      <!-- 下载APP -->
      <div
        class="code-outer-box"
        :class="code ? 'code-outer-box-down' : ''"
        @mouseenter="code = true"
        @mouseleave="code = false"
      >
        <div class="code-box">
          <div class="code-inner-box">
            <img src="../../../assets/footer_code_img.png" />
            <span>企业端</span>
          </div>
          <div class="code-inner-box">
            <img src="../../../assets/footer_code_img.png" />
            <span>人才端</span>
          </div>
          <div class="code-inner-box">
            <img src="../../../assets/footer_code_img.png" />
            <span>协会端</span>
          </div>
        </div>
      </div>
      <button>协会登录</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["topVal"],
  data() {
    return {
      navAct: "/home",
      nav: [
        {
          title: "首页",
          path: "/home",
        },
        {
          title: "解决方案",
          path: "",
          child: [
            {
              name: "商协会解决方案",
              path: "/association",
            },
            {
              name: "企业解决方案",
              path: "/enterprise",
            },
            {
              name: "企业IPO解决方案",
              path: "/corporate",
            },
            {
              name: "知识产权解决方案",
              path: "/intellectual",
            },
            {
              name: "产品研发解决方案",
              path: "/product",
            },
            {
              name: "人才解决方案",
              path: "/talent",
            },
          ],
        },
        {
          title: "产品中心",
          path: "",
          child: [
            {
              name: "人才管理系统",
              path: "/talent-manage",
            },
            {
              name: "产业数字金融",
              path: "/digital",
            },
            {
              name: "产业咨询中心",
              path: "/industrial",
            },
            {
              name: "元宇宙虚拟世界",
              path: "/metaverse",
            },
          ],
        },
        {
          title: "客户案例",
          path: "/case",
        },
        {
          title: "合作入驻",
          path: "/cooperation",
        },
        {
          title: "资讯中心",
          path: "/info",
        },
        {
          title: "关于我们",
          path: "/about",
        },
        {
          title: "智能AI",
          path: "/ai",
        },
        {
          title: "下载APP",
          path: "",
        },
      ],
      solution: false,
      product: false,
      code: false,
    };
  },
  methods: {
    toPage(item) {
      if (this.$route.path !== item.path) {
        if (
          item.title !== "下载APP" &&
          item.title !== "解决方案" &&
          item.title !== "产品中心"
        ) {
          this.navAct = item.path;
          this.$router.push({ path: `${item.path}` });
        }
      }
    },
    toSecondPage(path) {
      if (this.$route.path !== path) {
        if (
          path === "/association" ||
          path === "/enterprise" ||
          path === "/corporate" ||
          path === "/intellectual" ||
          path === "/product" ||
          path === "/talent"
        ) {
          this.navAct = "/solution";
        } else {
          this.navAct = "/product";
        }
        this.$router.push({ path: `${path}` });
      }
    },
    downMenu(title) {
      if (title === "解决方案") {
        this.solution = true;
      } else if (title === "产品中心") {
        this.product = true;
      } else if (title === "下载APP") {
        this.code = true;
      }
    },
    upMenu(title) {
      if (title === "解决方案") {
        this.solution = false;
      } else if (title === "产品中心") {
        this.product = false;
      } else if (title === "下载APP") {
        this.code = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.header-box {
  width: 100%;
  height: 6.25rem;
  padding: 0 13.125rem;
  background-color: rgba(20, 20, 20, 0);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1998;
  transition: all 0.5s ease;
  .logo {
    width: 8.75rem;
    height: 3rem;
    margin-right: 18.0625rem;
  }
  .nav-box {
    width: 57rem;
    height: 6.25rem;
    margin-right: 3.75rem;
    display: flex;
    justify-content: space-between;
    .nav {
      height: 6.25rem;
      font-weight: 400;
      font-size: 1.125rem;
      color: #ffffff;
      // line-height: 6.25rem;
      line-height: 1.5625rem;
      text-decoration: none;
      cursor: pointer;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .nav-active {
      color: #f5dfc4;
    }
    .line {
      // width: 2.25rem;
      width: 100%;
      height: 0.125rem;
      background-color: #f5dfc4;
      // position: absolute;
      // left: 39.9375rem;
      // top: 4rem;
      margin-top: 0.1875rem;
    }
  }
  .secondary-menu-box {
    position: absolute;
    top: 6.25rem;
    left: 39.5625rem;
    .secondary-menu {
      width: 15.25rem;
      // background: rgba(26, 26, 26, 0.95);
      background-color: rgba(255, 255, 255, 1);
      border-radius: 1.25rem;
      .menu-item {
        display: none;
        width: 15.25rem;
        height: 1.5625rem;
        margin-bottom: 1.875rem;
        font-weight: 400;
        font-size: 1.125rem;
        color: #141414;
        text-decoration: none;
        line-height: 1.5625rem;
        text-align: center;
        cursor: pointer;
      }
      .menu-item:hover {
        color: #c89f73;
      }
      .menu-item:last-child {
        margin-bottom: 0;
      }
    }
  }
  .secondary-menu-box-two {
    left: 46.5625rem;
  }

  .secondary-menu-box-down {
    padding-top: 0.625rem;
    // transition: all 0.5s ease;
    .secondary-menu {
      height: 18.75rem;
      padding: 2.5rem 0;
      // transition: all 0.5s ease;
      .menu-item {
        display: block;
      }
    }
  }

  .secondary-menu-box-two-down {
    .secondary-menu {
      height: 11.875rem;
    }
  }

  .code-outer-box {
    position: absolute;
    top: 6.25rem;
    left: 78.25rem;
    .code-box {
      width: 29.0625rem;
      // height: 12.1875rem;
      padding: 0 2.5rem;
      box-sizing: border-box;
      background: rgba(26, 26, 26, 0.95);
      border-radius: 1.25rem;
      display: flex;
      justify-content: space-between;
      .code-inner-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 0;
          height: 0;
        }
        span {
          height: 1.5625rem;
          font-weight: 400;
          font-size: 1.125rem;
          color: #ffffff;
          line-height: 1.5625rem;
          display: none;
        }
      }
    }
  }
  .code-outer-box-down {
    padding-top: 0.625rem;
    // transition: all 0.5s ease;
    .code-box {
      height: 14.375rem;
      padding: 2.5rem 2.5rem;
      // transition: all 0.5s ease;
      .code-inner-box {
        img {
          width: 7.1875rem;
          height: 7.1875rem;
          margin-bottom: 0.625rem;
          // transition: all 0.5s ease;
        }
        span {
          display: block;
        }
      }
    }
  }

  button {
    width: 6.1875rem;
    height: 2.1875rem;
    border-radius: 2.5rem;
    border: 0.0625rem solid #f5dfc4;
    box-sizing: border-box;
    font-weight: 400;
    font-size: 1rem;
    color: #f5dfc4;
    line-height: 2.0625rem;
    text-align: center;
    background-color: rgba(245, 223, 196, 0);
    cursor: pointer;
  }
}
.header-box:hover {
  background-color: rgba(20, 20, 20, 1);
}
.header-active {
  background-color: rgba(20, 20, 20, 1);
  transition: all 0.5s ease;
}
</style>
